import styles from "./TruckDimensionReview.module.css";

export default function TruckDimensionReview({ dimensions, onChange, show }) {
  if (!show) return null;

  // Define options for the dropdowns with labels and codes
  const axleTypeOptions = [
    { label: "Single Axle", value: "SA" },
    { label: "Multi Axle", value: "MA" },
  ];

  // keeping backend and UI value is a hack, fix this later via backend
  const bodyTypeOptions = [
    { label: "Open Body", uiValue: "open", backend: "OB" },
    { label: "Flatbed", uiValue: "flatbed", backend: "OB" },
    { label: "Closed Body", uiValue: "closed", backend: "CB" },
    { label: "Container", uiValue: "container", backend: "CB" },
    { label: "Tanker", uiValue: "tanker", backend: "CB" },
    { label: "Reefer", uiValue: "reefer", backend: "RF" },
  ];

  return (
    <>
      {/* Tip pointing towards Truck Selector */}
      <div className={styles.tipContainer}>
        <div className={styles.tipArrow}></div>
      </div>

      <div className={styles.reviewContainer}>
        <div className={styles.reviewTitle}>
          Review Inferred Truck Dimensions
        </div>
        <div className={styles.rowGroup}>
          <div className={styles.fieldBox}>
            <label htmlFor="capacity_mt">Capacity (MT)</label>
            <input
              type="text"
              name="capacity_mt"
              value={dimensions.capacity_mt}
              onChange={(e) => onChange("capacity_mt", e.target.value)}
            />
          </div>
          <div className={styles.fieldBox}>
            <label htmlFor="length_ft">Length (FT)</label>
            <input
              type="text"
              name="length_ft"
              value={dimensions.length_ft}
              onChange={(e) => onChange("length_ft", e.target.value)}
            />
          </div>

          {/* Axle Type Dropdown */}
          <div className={styles.fieldBox}>
            <label htmlFor="axle_type">Axle Type</label>
            <select
              name="axle_type"
              value={dimensions.axle_type}
              onChange={(e) => onChange("axle_type", e.target.value)}
            >
              {axleTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Body Type Dropdown */}
          <div className={styles.fieldBox}>
            <label htmlFor="body_type">Body Type</label>
            <select
              name="body_type"
              value={dimensions.body_type_ui || ""} // bind to UI value so label stays
              onChange={(e) => {
                const ui = e.target.value;
                const opt = bodyTypeOptions.find((o) => o.uiValue === ui);
                // update both: human choice and backend code
                onChange("body_type_ui", ui);
                onChange("body_type", opt ? opt.backend : "");
              }}
            >
              {bodyTypeOptions.map((o) => (
                <option key={o.uiValue} value={o.uiValue}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </>
  );
}
